import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { GraduationCap, Sparkle } from "@phosphor-icons/react";

export default function LoginPage() {
  const { login, error } = useAuth();
  const [email, setEmail] = useState("demo@edufin.com");
  const [password, setPassword] = useState("Demo1234!");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  async function onSubmit(e) {
    e.preventDefault();
    setLoading(true);
    const ok = await login(email, password);
    setLoading(false);
    if (ok) nav("/");
  }

  return (
    <div className="min-h-screen grid md:grid-cols-2">
      {/* Visual panel */}
      <div className="hidden md:flex relative overflow-hidden bg-[#3A5A40]">
        <img
          src="https://images.unsplash.com/photo-1764743111075-fb988af9ed75?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzV8MHwxfHNlYXJjaHwxfHxjYWxtJTIwbmV1dHJhbCUyMHdvcmtzcGFjZXxlbnwwfHx8fDE3NzY1MTUwNTJ8MA&ixlib=rb-4.1.0&q=85"
          alt=""
          className="absolute inset-0 w-full h-full object-cover opacity-60 mix-blend-luminosity"
        />
        <div className="absolute inset-0 bg-gradient-to-br from-[#3A5A40]/90 via-[#3A5A40]/70 to-[#1A2E1C]/90" />
        <div className="relative z-10 p-12 flex flex-col justify-between text-white w-full">
          <div className="flex items-center gap-2">
            <GraduationCap size={28} weight="duotone" />
            <span className="font-display font-bold text-xl">EduFin</span>
          </div>
          <div className="max-w-md">
            <Sparkle size={32} weight="duotone" className="mb-4 text-[#E9C46A]" />
            <h1 className="font-display text-4xl lg:text-5xl font-bold leading-tight mb-4">
              Özel derslerinizi sade, profesyonel bir şekilde yönetin.
            </h1>
            <p className="text-white/80 text-base">
              Takvim, ders onayı, ödeme takibi ve aylık veli raporları — tek bir panelden.
            </p>
          </div>
          <div className="text-xs text-white/60">© EduFin · Öğretmenler için.</div>
        </div>
      </div>

      {/* Form panel */}
      <div className="flex items-center justify-center p-6 md:p-12">
        <form onSubmit={onSubmit} className="w-full max-w-md space-y-6" data-testid="login-form">
          <div>
            <h2 className="font-display text-3xl font-bold text-foreground">Tekrar hoş geldiniz</h2>
            <p className="text-muted-foreground mt-1">Hesabınıza giriş yapın.</p>
          </div>

          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">E-posta</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="siz@ornek.com"
                required
                data-testid="login-email-input"
              />
            </div>
            <div className="space-y-2">
              <Label htmlFor="password">Şifre</Label>
              <Input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                required
                data-testid="login-password-input"
              />
            </div>
          </div>

          {error && (
            <div className="text-sm text-[#D97757] bg-[#FFF3E0] border border-[#FFE0B2] rounded-md px-3 py-2" data-testid="login-error">
              {error}
            </div>
          )}

          <Button type="submit" disabled={loading} className="w-full bg-[#3A5A40] hover:bg-[#2E4833] text-white h-11" data-testid="login-submit-button">
            {loading ? "Giriş yapılıyor…" : "Giriş Yap"}
          </Button>

          <div className="text-sm text-muted-foreground">
            Hesabınız yok mu?{" "}
            <Link to="/kayit" className="text-[#3A5A40] font-medium hover:underline" data-testid="goto-register-link">
              Hemen kaydolun
            </Link>
          </div>

          <div className="rounded-md bg-muted p-3 text-xs text-muted-foreground">
            <div className="font-medium text-foreground mb-1">Demo Hesap</div>
            demo@edufin.com · Demo1234!
          </div>
        </form>
      </div>
    </div>
  );
}
